import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { WaitingUserItem } from "../types";

interface UseWaitingUsersListArgs {
  corporateId: string | number;
  objectId: number;
  editionId?: number;
  page: number;
  pageSize: number;
  search?: string;
  status?: string;
  enrollType?: string;
}

export const useWaitingUsersList = ({
  corporateId,
  objectId,
  editionId,
  page,
  pageSize,
  search,
  status,
  enrollType,
}: UseWaitingUsersListArgs): PaginatedListResult<WaitingUserItem> => {
  const editionParam = editionId ? `&editionId=${editionId}` : "";
  const url = corporateId
    ? `${ServicesURL.getUsersWaiting}?corporateId=${corporateId}&objectId=${objectId}${editionParam}`
    : null;

  return usePaginatedList<WaitingUserItem>(
    url,
    {
      page,
      pageSize,
      search,
      fieldFilters: {
        ...(status ? { status } : {}),
        ...(enrollType ? { enrollType } : {}),
      },
    },
    {
      responseKey: "output",
      totalElementsKey: "total_elements",
      totalPagesKey: "total_pages",
    },
  );
};
